import axiosCall from "../../axiosCall";
import { CPR_AUTH, FAF_AUTH, PARTNER_AUTH, CPR_BROWSERID, FAF_BROWSERID } from '../../../constant/Constants'
import { resetSessionTiming } from "../../sessionManagement";


// Partner table based patient search
export const fetchSearchPatient = async ({ BrowserId, data, EIN, authorization, prgData }) => {
    resetSessionTiming()
    let dateOfBirth = data.dob.value != '' ? `${data.dob.value.substring(5, 7)}/${data.dob.value.substring(8, 10)}/${data.dob.value.substring(0, 4)}` : '';

    let reqBody = {
        "PartnerPatient":
        {
            "FirstName": data.firstName.value,
            "LastName": data.lastName.value,
            "DateOfBirth": dateOfBirth,
            "SocialSecurityNumber": data.ssn.value,
            "AlienNumber": data.alienNumber.value
        },
        "Partner": {
            "EINNumber": EIN,
            "ProviderID": `E-${EIN}`,
        }

    }
    const response = await axiosCall('post', `/Partner/v1/SearchPatient/Partner?`, authorization, `BrowserID=${BrowserId}`, reqBody, prgData.PROGRAM);
    return response.data
}



// Program Based D_Member page details
export const fetchPatientDetails = async ({ memberId, prgData }) => {
    resetSessionTiming()
    let authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const response = await axiosCall('get', `/v1/data/D_Member_Lookup?`, authorization, `MemberID=${memberId}`, null, prgData);
    return { res: response.data, program: prgData }
}

// Create Patient
export const createPatientAPI = async ({ reqBody, browserId, portalUserId, prgData }) => {
    resetSessionTiming()
    const response = await axiosCall('post', `/Partner/v1/CreatePatient/?`, PARTNER_AUTH, `BrowserID=${browserId}&PortalUserID=${portalUserId}`, reqBody, prgData);
    return response.data
}

// Program Specific Patient Search
export const searchPatientByProgram = async ({ data, prgData, patientPartnerID }) => {
    resetSessionTiming()
    let authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const response = await axiosCall('post', `/Users/v1/SearchPatient/${prgData}?`, authorization, `BrowserID=${browserID}`, data, prgData);
    return { res: response.data, program: prgData, patientPartnerId: patientPartnerID }
}

// / Partner Member table
export const fetchPatientMemberInPartner = async ({ memberId, prgData, selectedProgram }) => {
    resetSessionTiming()
    const response = await axiosCall('get', `/v1/data/D_Partner_Lookup?`, PARTNER_AUTH, `MemberID=${memberId}`, null, prgData);
    return { res: response.data, program: selectedProgram }
}
export const getFatchPhoneNumberAPI = async () => {
    resetSessionTiming()
    const response = await axiosCall('get', `/v1/data/D_ProgramDetails?`, PARTNER_AUTH, `FundGroup=Partner`, null, 'FAF');
    return { res: response.data }
}